import React from "react"
import classes from "./UserPanel.module.scss"
import {useAppSelector} from "../../../../../hooks/redux"
import getRole from "../../../../../utils/getRole"
import {useNavigate} from "react-router-dom"

export default function UserPanel() {

  const { fio, role_id } = useAppSelector(state => state.auth.user)
  const role = getRole(role_id)
  const navigate = useNavigate()
  const [firstWord, secondWord] = fio.split(" ")
  const firstChar = firstWord !== undefined ? firstWord.charAt(0) : ''
  const secondChar = secondWord !== undefined ? secondWord.charAt(0) : ''

  const clickHandler = () => {
    navigate('/profile/')
  }

  return(
    <div className={classes.wrap} onClick={clickHandler}>
      <div className={classes.info}>
        <div className={classes.name}>{fio}</div>
        <div className={classes.role}>{role?.name}</div>
      </div>
      <div className={classes.square}>{`${firstChar}${secondChar}`}</div>
    </div>
  )
}